import React from 'react';
import { ProductContainer } from '@app/product/style';
import Skeleton from 'react-loading-skeleton';

const ProductLoader = () => {
  return (
    <ProductContainer>
      {[
        ...new Array(6).map((_, idx) => (
          <div className="card" key={idx}>
            <Skeleton style={{ width: '100%', height: '304px' }} />
            <Skeleton width={100} />
            <Skeleton width={150} style={{ marginBottom: '1px' }} />
            <Skeleton width={250} style={{ marginBottom: '1px' }} />
          </div>
        )),
      ]}
    </ProductContainer>
  );
};

export default ProductLoader;
